module.exports = __webpack_public_path__ + "Roboto-Bold.ee7b96fa85d8fdb8c126.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Bold.ttf
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Bold.ttf
// module chunks = styles